<template>
  <!-- 组件 -->
  <div class="download_code_page">
    <div class="down_img" id="downImg" ref="downImg">
      <img
        class="img"
        src="http://mlwccy.oss-cn-qingdao.aliyuncs.com/2024-09-13/ca99d21340be491fa1c5c370bbae5e27.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    responseImg: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      url: "",
    };
  },
  //过滤器
  filters: {},
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  //生命周期 创建后
  created() {},
  // 挂载后
  mounted() {},
  // 销毁前
  beforeDestroy() {},
  //自定义函数
  methods: {
    async getCodeDown() {
      const content = this.$refs.downImg;
      const canvas = await html2canvas(content, {
        useCORS: true,
      });
      const imgData = canvas.toDataURL("image/png");
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
      });
      const imgProps = doc.getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      doc.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      doc.save("download.pdf");
      //   html2canvas(document.querySelector("#downImg"), {
      //     scale: 2, //分辨率
      //     useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
      //   }).then((canvas) => {
      //     // 创建一个图片元素
      //     var img = canvas.toDataURL("image/png");

      //     // 创建一个链接元素
      //     var link = document.createElement("a");

      //     // 设置下载属性
      //     link.href = img;
      //     link.download = "screenshot.png";

      //     // 触发下载
      //     link.click();
      //   });
      //   console.log("图片元素++-+");
      //   const canvas = await html2canvas(document.querySelector("#downImg"), {
      //     backgroundColor: "#e8f4ff",
      //     scale: 2, //分辨率
      //     useCORS: true, // 如果截图的内容里有图片,可能会有跨域的情况,加上这个参数,解决文件跨域问题
      //   });
      //   console.log("图片元素1", canvas);
      //   const img = canvas.toDataURL("image/png");
      //   console.log("图片元素2", img);

      //   // 这里可以将img元素插入到DOM中，例如插入到body中
      //   //   document.body.appendChild(img);
      //   const formData = new FormData();
      //   //   formData.append("file", this.dataURLtoFile(img, "image.png"));

      //   //   console.log("图片元素", formData);

      //   // 或者可以直接下载图片
      //   let a = document.createElement("a");
      //   a.href = img.src;
      //   a.download = "downImg.png";
      //   a.click();
    },
    dataURLtoFile(dataurl, filename) {
      // console.log("dataurl", dataurl);
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
  },
};
</script>

<style scoped lang="scss">
.download_code_page {
  //   width: 0;
  //   height: 0;
  //   overflow: hidden;
  .down_img {
    width: 400px;
    height: 400px;
    .img {
      width: 400px;
      height: 400px;
    }
  }
}
</style>
